<template>
  <div>
    <img v-if="imgUrl" :src="imgUrl" width="100%" />
    <img v-else src="../../../public/gateway/index/bgImg.png" width="100%" />
    <div class="index">
      <div class="index-box">
        <div v-if="noticeList.length" class="title">通知与公告</div>
        <div v-if="noticeList.length" class="notice">
          <div
            v-for="(item, index) in noticeList"
            :key="index"
            @click="goNoticeDetail(item)"
            class="notice-box"
          >
            <img :src="item.iconUrl" />
            <div class="box-r">
              <div class="box-title">{{ item.title }}</div>
              <div class="box-btn">查看 ></div>
            </div>
          </div>
        </div>
        <!-- <div class="title">当前的活动</div>
        <div class="activity">
          <div
            v-for="(item, index) in noticeList"
            :key="index"
            class="activity-box"
          >
            <img :src="item.img" />
            <div class="box-r">
              <div>
                <div class="box-title">{{ item.title }}</div>
                <div class="box-content">{{ item.time }}</div>
                <div class="box-content">{{ item.ac }}</div>
              </div>
              <div class="box-btn">了解更多 ></div>
            </div>
          </div>
        </div> -->
        <div v-if="courseList.length" class="title">精彩课程</div>
        <div class="course">
          <div
            v-for="(item, index) in courseList"
            :key="index"
            @click="goCourseDetail(item)"
            class="course-box"
          >
            <img v-if="item.coverUrl" :src="item.coverUrl" />
            <img v-else src="../../../public/gateway/course/defaultImg.png" />
            <div class="box-title">{{ item.courseName }}</div>
          </div>
        </div>
        <div v-if="courseList.length" @click="goMoreCourse()" class="courseBtn">
          探索更多课程 >
        </div>
        <div class="title">更多</div>
        <div class="platform">
          <div class="parent">
            <img
              src="../../../public/gateway/index/parent@2x.png"
              width="100%"
              class="parent-img"
            />
            <div class="parent-box">
              <div class="parent-name">家长端</div>
              <div @click="goParent()" class="parent-btn">立即进入</div>
            </div>
          </div>
          <div>
            <div class="teacher">
              <img
                src="../../../public/gateway/index/teacher@2x.png"
                width="100%"
                class="teacher-img"
              />
              <div class="teacher-box">
                <div @click="goTeacher()" class="teacher-btn">
                  进入教师端小程序
                </div>
              </div>
            </div>
            <div class="manage">
              <img
                src="../../../public/gateway/index/manage@2x.png"
                width="100%"
                class="manage-img"
              />
              <div class="manage-box">
                <div @click="goManage()" class="manage-btn">进入管理平台</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div>课后三点半&nbsp;&nbsp;&nbsp;&nbsp;重新定义成长</div>
      </div>
    </div>
  </div>
</template>

<script>
import gateway from '../../api/gateway'

export default {
  name: 'index',
  data() {
    return {
      imgUrl: '',
      noticeList: [],
      courseList: [],
      loginUrl: '', // 管理端登录地址
    }
  },
  created() {
    this.getSchoolInfo()
    this.getAnnouncements()
  },
  methods: {
    getSchoolInfo() {
      gateway.getSchoolInitData().then((res) => {
        this.imgUrl = res.data.imgUrl
        this.courseList = res.data.courseList
        this.loginUrl = res.data.loginUrl
      })
    },
    getAnnouncements() {
      gateway.getAnnouncements().then((res) => {
        this.noticeList = res.data
      })
    },
    // 探索更多课程
    goMoreCourse() {
      this.$emit('changeOption', 1)
    },
    // 前往家长端
    goParent() {
      this.$router.push('parent')
      this.$emit('changeOption', 2)
    },
    // 前往教师端
    goTeacher() {
      this.$router.push('more')
      this.$emit('changeOption', 3)
    },
    // 前往登录页面
    goManage() {
      if (this.loginUrl) location.href = `https://${this.loginUrl}/#/login`
    },
    goNoticeDetail(e) {
      this.$router.push({
        name: 'newsDetail',
        query: {
          id: e.id,
        },
      })
    },
    goCourseDetail(e) {
      this.$router.push({
        name: 'courseDetail',
        query: {
          id: e.id,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'src/config/var';

html body {
  width: 100%;
}

@media screen and (min-width: 510px) {
  .index {
    width: 100%;
    background-color: #f7f7f7;

    .index-box {
      width: 100%;
      padding: 40px 0 0;
      max-width: 1100px;
      @media screen and (min-width: 1441px) {
        max-width: 1500px;
      }
      margin: 0 auto;
      .title {
        width: 100%;
        font-size: 48px;
        color: #151517;
      }

      .notice {
        width: 100%;
        margin: 40px 0;
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .notice-box {
          width: 454px;
          // min-width: 414px;
          height: 120px;
          background-color: #ffffff;
          border-radius: 10px;
          margin: 0 30px 20px 0;
          display: flex;
          cursor: pointer;

          img {
            width: 120px;
            height: 120px;
            border-radius: 10px;
            object-fit: cover;
          }

          .box-r {
            flex: 1;
            height: 100%;
            padding: 16px 24px;
            display: flex;
            justify-content: space-between;
            flex-direction: column;

            .box-title {
              width: 100%;
              font-size: 18px;
              font-weight: 600;
              overflow: hidden;
              -webkit-line-clamp: 2;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
            }

            .box-btn {
              color: #1890ff;
              // margin-top: 24px;
            }
          }
        }
      }

      .activity {
        width: 100%;
        margin: 40px 0 60px 0;
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .activity-box {
          width: 690px;
          height: 240px;
          background-color: #ffffff;
          border-radius: 10px;
          margin: 0 40px 20px 0;
          display: flex;

          img {
            width: 320px;
            height: 240px;
            border-radius: 10px 0 0 10px;
          }

          .box-r {
            flex: 1;
            height: 100%;
            padding: 16px 24px;
            display: flex;
            justify-content: space-between;
            flex-direction: column;

            .box-title {
              width: 100%;
              font-size: 22px;
              font-weight: 600;
              overflow: hidden;
              -webkit-line-clamp: 2;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
            }

            .box-content {
              overflow: hidden;
              -webkit-line-clamp: 2;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              margin-top: 10px;
            }

            .box-btn {
              color: #1890ff;
              // margin-top: 24px;
            }
          }
        }
      }

      .course {
        width: 100%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .course-box {
          width: 454px;
          height: 332px;
          margin-right: 30px;
          background-color: #ffffff;
          border-radius: 10px;
          margin-top: 40px;
          cursor: pointer;

          img {
            width: 100%;
            height: 254px;
            border-radius: 10px 10px 0 0;
            object-fit: cover;
          }

          .box-title {
            width: 100%;
            font-size: 22px;
            font-weight: 600;
            padding: 24px;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
            white-space: nowrap;
          }
        }
      }

      .courseBtn {
        width: 300px;
        height: 80px;
        font-size: 24px;
        font-weight: 600;
        color: #1890ff;
        background-color: #ffffff;
        border-radius: 50px;
        margin: 90px auto 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }

    .platform {
      width: 100%;
      margin-top: 40px;
      display: flex;

      .parent {
        width: 700px;
        height: 960px;
        background: url('../../../public/gateway/index/parent@2x.png') no-repeat;
        background-size: 100% 100%;
        padding-bottom: 70px;
        margin-right: 40px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-direction: column;

        .parent-img {
          display: none;
        }

        .parent-box {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          .parent-name {
            font-size: 58px;
            color: #ffffff;
            font-weight: 600;
          }

          .parent-btn {
            width: 366px;
            height: 80px;
            font-size: 32px;
            color: #1dca78;
            font-weight: 600;
            background-color: #ffffff;
            border-radius: 50px;
            box-shadow: 0px 8px 18px 0px rgba(22, 60, 31, 0.18);
            margin-top: 42px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          }
        }
      }

      .teacher {
        width: 700px;
        height: 460px;
        background: url('../../../public/gateway/index/teacher@2x.png')
          no-repeat;
        background-size: 100% 100%;
        padding-bottom: 46px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-direction: column;

        .teacher-img {
          display: none;
        }

        .teacher-btn {
          width: 288px;
          height: 68px;
          font-size: 24px;
          color: #00abff;
          font-weight: 600;
          background-color: #ffffff;
          border-radius: 50px;
          box-shadow: 0px 8px 18px 0px rgba(22, 60, 31, 0.18);
          margin-top: 42px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
      }

      .manage {
        width: 700px;
        height: 460px;
        background: url('../../../public/gateway/index/manage@2x.png') no-repeat;
        background-size: 100% 100%;
        padding-bottom: 46px;
        margin-top: 40px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-direction: column;

        .manage-img {
          display: none;
        }

        .manage-btn {
          width: 288px;
          height: 68px;
          font-size: 24px;
          color: #0060ff;
          font-weight: 600;
          background-color: #ffffff;
          border-radius: 50px;
          box-shadow: 0px 8px 18px 0px rgba(22, 60, 31, 0.18);
          margin-top: 42px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
      }
    }

    .mr-40 {
      margin-right: 40px;
    }
  }

  .bottom {
    width: 100%;
    height: 220px;
    background: url('../../../public/gateway/index/bottom@2x.png') no-repeat;
    background-size: 100% 100%;
    margin-top: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    div {
      font-size: 48px;
      color: #ffffff;
    }
  }
}
@media screen and (max-width: 510px) {
  .index {
    width: 100%;
    padding: 15px 20px 30px;
    background-color: #f7f7f7;

    .index-box {
      width: 100%;
      margin: 0 auto;
      .title {
        width: 100%;
        font-size: 20px;
        color: #151517;
      }

      .notice {
        width: 100%;
        margin: 20px 0 0;
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .notice-box {
          width: 100%;
          height: 120px;
          background-color: #ffffff;
          border-radius: 10px;
          margin: 0 30px 20px 0;
          display: flex;

          img {
            width: 120px;
            height: 120px;
            border-radius: 10px;
            object-fit: cover;
          }

          .box-r {
            flex: 1;
            height: 100%;
            padding: 16px 24px;
            display: flex;
            justify-content: space-between;
            flex-direction: column;

            .box-title {
              width: 100%;
              font-size: 18px;
              font-weight: 600;
              overflow: hidden;
              -webkit-line-clamp: 2;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
            }

            .box-btn {
              color: #1890ff;
              // margin-top: 24px;
            }
          }
        }
      }

      .activity {
        width: 100%;
        margin: 40px 0 60px 0;
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .activity-box {
          width: 690px;
          height: 240px;
          background-color: #ffffff;
          border-radius: 10px;
          margin: 0 40px 20px 0;
          display: flex;

          img {
            width: 320px;
            height: 240px;
            border-radius: 10px 0 0 10px;
          }

          .box-r {
            flex: 1;
            height: 100%;
            padding: 16px 24px;
            display: flex;
            justify-content: space-between;
            flex-direction: column;

            .box-title {
              width: 100%;
              font-size: 22px;
              font-weight: 600;
              overflow: hidden;
              -webkit-line-clamp: 2;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
            }

            .box-content {
              overflow: hidden;
              -webkit-line-clamp: 2;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              margin-top: 10px;
            }

            .box-btn {
              color: #1890ff;
              // margin-top: 24px;
            }
          }
        }
      }

      .course {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;

        .course-box {
          width: 48%;
          background-color: #ffffff;
          border-radius: 5px;
          margin-top: 20px;

          img {
            width: 100%;
            height: 85px;
            border-radius: 5px 5px 0 0;
            object-fit: cover;
          }

          .box-title {
            width: 100%;
            font-size: 11px;
            font-weight: 600;
            padding: 8px 12px;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
            white-space: nowrap;
          }
        }
      }

      .courseBtn {
        width: 150px;
        height: 40px;
        font-size: 12px;
        font-weight: 600;
        color: #1890ff;
        background-color: #ffffff;
        border-radius: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px auto;
      }
    }

    .platform {
      width: 100%;
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;

      .parent {
        width: 100%;
        height: auto;
        background-size: 100% 100%;
        position: relative;

        .parent-box {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          bottom: 40px;
          left: 0;
          position: absolute;

          .parent-name {
            font-size: 28px;
            color: #ffffff;
            font-weight: 600;
          }

          .parent-btn {
            width: 182px;
            height: 40px;
            font-size: 16px;
            color: #1dca78;
            font-weight: 600;
            background-color: #ffffff;
            border-radius: 50px;
            box-shadow: 0px 8px 18px 0px rgba(22, 60, 31, 0.18);
            margin-top: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }

      .teacher {
        width: 100%;
        height: auto;
        background-size: 100% 100%;
        margin-top: 15px;
        position: relative;

        .teacher-box {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          flex-direction: column;
          bottom: 24px;
          left: 0;
          position: absolute;

          .teacher-btn {
            width: 144px;
            height: 34px;
            font-size: 12px;
            color: #00abff;
            font-weight: 600;
            background-color: #ffffff;
            border-radius: 50px;
            box-shadow: 0px 8px 18px 0px rgba(22, 60, 31, 0.18);
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }

      .manage {
        width: 100%;
        background-size: 100% 100%;
        margin-top: 15px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-direction: column;
        position: relative;

        .manage-box {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          flex-direction: column;
          bottom: 24px;
          left: 0;
          position: absolute;

          .manage-btn {
            width: 144px;
            height: 34px;
            font-size: 12px;
            color: #0060ff;
            font-weight: 600;
            background-color: #ffffff;
            border-radius: 50px;
            box-shadow: 0px 8px 18px 0px rgba(22, 60, 31, 0.18);
            margin-top: 42px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }

    .mr-40 {
      margin-right: 40px;
    }
  }

  .bottom {
    width: 100%;
    height: 100px;
    background: url('../../../public/gateway/index/bottom@2x.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    div {
      font-size: 24px;
      color: #ffffff;
    }
  }
}
</style>
